const customStyles = {
  container: (provided: any) => ({
    ...provided,
    width: "100%",
  }),

  control: (provided: any, state: any) => ({
    ...provided,
    background: "#fff",
    borderRadius: 7,
    borderColor: state.selectProps.error ? "red" : "#fff",
    minHeight: "26px",
    height: "26px",
    boxShadow: state.isFocused ? null : null,
  }),

  valueContainer: (provided: any, state: any) => ({
    ...provided,
    height: "26px",
    padding: "0 6px",
  }),

  input: (provided: any, state: any) => ({
    ...provided,
    margin: "0px",
  }),

  indicatorsContainer: (provided: any, state: any) => ({
    ...provided,
    height: "26px",
  }),
};

const averageConsumptionStyles = {
  container: (provided: any) => ({
    ...provided,
    width: "100%",
    margin: "0px"
  }),

  control: (provided: any, state: any) => ({
    ...provided,
    background: "transparent",
    border: "none",
    minHeight: "18px",
    height: "18px",
    boxShadow: state.isFocused ? null : null,
    color: "black",
  }),

  option: (provided: any, state: any) => ({
    color: "black",
  }),

  menuPortal: (provided: any, state: any) => ({
    offset: 100,
    rect: {
      left: -30,
    }
  }),

  valueContainer: (provided: any, state: any) => ({
    ...provided,
    height: "18px",
    padding: "0 6px",
  }),

  input: (provided: any, state: any) => ({
    ...provided,
    margin: "0px",
  }),

  indicatorsContainer: (provided: any, state: any) => ({
    ...provided,
    height: "18px",
  }),
};

export const styles = {
  customStyles, averageConsumptionStyles
};

export default customStyles;
